export default "__VITE_ASSET__BJsu1IzN__"